import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state.roofTypeState || initialState;

export const selectRoofTypeLoading = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.loading
);

export const selectRoofTypeList = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.list
);

export const selectRoofTypeMeta = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.meta
);

export const selectRoofTypePage = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.page
);

export const selectRoofTypePerPage = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.isAddModalOpen
);

export const selectRoofTypeForm = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.form
);

export const selectRoofTypeSaving = createSelector(
  [selectDomain],
  (roofTypeState) => roofTypeState.saving
);
